<main class="no-permission-container" role="main">
  <div
    class="no-permission-content"
    role="alert"
    aria-live="polite"
    tabindex="0"
  >
    <div class="icon-container" aria-hidden="true">
      <mat-icon class="warning-icon">lock</mat-icon>
    </div>

    <h1 [innerHTML]="title"></h1>

    <p class="message" id="permission-message">
      {{ 'NO_PERMISSION.MESSAGE' | translate }}
    </p>

    <div class="actions">
      <button
        mat-raised-button
        color="primary"
        (click)="goHome()"
        aria-describedby="permission-message"
        class="home-button"
      >
        {{ 'NO_PERMISSION.GO_HOME' | translate }}
      </button>
    </div>
  </div>
</main>
